import { urlBuilder } from '@starjack/utils';
import { createEntityApi, type EntityEndpointBuilder } from '@starjack/api';
import { B2BUserWithCredentials } from '../model/b2b.types';

type GetB2BResponse = {
    b2bUsers: B2BUserWithCredentials[];
};

export const b2bUrls = () => ({
    b2b: urlBuilder('auth', 'b2b'),
});

export interface B2BApiHooks {
    useGetB2BUsersQuery: () => {
        data?: GetB2BResponse;
        isFetching: boolean;
        isLoading: boolean;
        error?: unknown;
    };
}

export const b2bEndpoints = (builder: EntityEndpointBuilder) => ({
    getB2BUsers: builder.query<GetB2BResponse, void>({
        query: () => b2bUrls().b2b,
        providesTags: ['B2B'],
    }),
});

export const b2bApi = createEntityApi({
    tagTypes: ['B2B'],
    endpoints: b2bEndpoints,
});

export const useGetB2BUsersQuery: B2BApiHooks['useGetB2BUsersQuery'] =
    b2bApi.useGetB2BUsersQuery;
